import {
  createContext,
  useContext,
  useLayoutEffect,
  type DependencyList,
  type Dispatch,
  type SetStateAction,
} from "react";

export type IntakeMobileChromeActions = {
  onContinue?: () => void;
  onCancel?: () => void;
  /** When false, hide Cancel even if onCancel is set */
  showCancel?: boolean;
  /** When false, hide Continue even if onContinue is set */
  showContinue?: boolean;
  continueLabel?: string;
  /** When false, hide the ↵ hint on the Continue button (e.g. external navigation). Default true. */
  continueShowKeyboardHint?: boolean;
  continueDisabled?: boolean;
  continueLoading?: boolean;
  onSkip?: () => void;
};

export const IntakeMobileChromeSetterContext =
  createContext<Dispatch<SetStateAction<IntakeMobileChromeActions | null>> | null>(
    null,
  );

/**
 * Publish bottom mobile actions for the current card. Pass a factory so the latest
 * handlers are used whenever `deps` change (avoids stale closures and setState loops).
 */
export function useIntakeMobileChromeRegistration(
  getSpec: () => IntakeMobileChromeActions | null,
  deps: DependencyList,
) {
  const set = useContext(IntakeMobileChromeSetterContext);

  useLayoutEffect(() => {
    if (!set) return;
    const spec = getSpec();
    if (!spec) {
      set(null);
      return;
    }
    set(spec);
    return () => set(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps drives when to re-read factory
  }, [set, ...deps]);
}
